import { EVINCED_SEVERITIES } from '@evinced-private/ui-common';

import { IIssuesOverviewResponse } from '../interfaces/IssuesOverviewResponse';

import { CustomSeverityNames, sumIssuesForDefaultSeverity } from './SeverityLabelHelper';

const getIssuesCount = (
	issuesOverviewReponse: IIssuesOverviewResponse,
	severity: EVINCED_SEVERITIES,
	customSeverityNames: CustomSeverityNames = {}
): number =>
	sumIssuesForDefaultSeverity(issuesOverviewReponse?.severities, severity, customSeverityNames);

export const ScanAndPropertyResultsHelper = { getIssuesCount };
